
<template>
  <div class="widthFull back-1 h-100" id="home">
    <loading v-if="loadingState" />
    <!-- HEADER -->
    <div id="top" class="container-fluid heroHome relative">
      <div class="row">
        <div class="col-3">
          <img
            v-if="vw > 991"
            src="../../assets/images/logo.png"
            class="img-fluid logoMob animatedLogo ml-4"
            ref="mainNavLogo"
          />
        </div>
      </div>
      <div class="row justify-content-center mt-lg-5 pt-lg-5">
        <div class="col-12 col-lg-6 mt-5 mt-lg-0 pt-5 pt-lg-0 center ">
          <img class="img-fluid img mt-4" src="../../assets/images/home.png" />
        </div>
        <div class="col-12 col-lg-4 mb-5 pb-4 pt-lg-5">
          <div class="Title h0 uppercase headerTitle mt-lg-5 pt-lg-5">
            <h3 class="black uppercase Medium pt-lg-4 pb-4" :class="{'h5':vw<600}">
              SCOPRI TUTTE LE ATTIVITÀ DI
              <b class="Bold">LABORATOIRE NATIVE</b> RISERVATE ALLE FARMACIE E
              AI PUNTI VENDITA ADERENTI
            </h3>
            <a
              v-if="isAuthenticated && moment(now,'DD-MM-YYYY') >= moment(start_intermedio,'DD-MM-YYYY')"
              v-scroll-to="{ el: '#active', offset: -85 }"
              class="btn Bold btn-primary"
              >Scopri di piú</a
            >
            <a
              v-if="isAuthenticated && moment(now,'DD-MM-YYYY') <= moment(start_intermedio,'DD-MM-YYYY')"
              v-scroll-to="{ el: '#coming_soon', offset: -85 }"
              class="btn Bold btn-primary"
              >Scopri di piú</a
            >
            <router-link
              v-else-if="!isAuthenticated"
              to="/login"
              href="#active"
              class="btn btn-primary Bold"
              >Effettua il login</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <!-- ACTIVE PROMOTIONS -->
    <Active v-if="isAuthenticated" id="active" class="zIndex2 relative" />
    <!-- COMING SOON PROMOTIONS -->
    <ComingSoon v-if="isAuthenticated" id="coming_soon" class="zIndex2 relative mb-5" />
    <!-- NOT ACTIVE PROMOTIONS -->
    <NotActive v-if="isAuthenticated" id="notActive" class="zIndex2 relative mb-5" />
    <!--------------------------->
  </div>
</template>

<script>
import { GET_PROMOTIONS, SET_PROMOTION } from "actions/auth";
import { mapGetters } from "vuex";
import Login from "components/login";
import Active from "./active.vue";
import NotActive from "./notActive.vue";
import ComingSoon from "./comingSoon.vue"
const moment = require("moment");
export default {
  name: "home",
  components: {
    Login,
    Active,
    NotActive,
    ComingSoon
  },
  data() {
    return {
      loadingState: false,
      moment: require("moment"),
      scroll: window.pageYOffset,
      now:moment(),
      start_intermedio:process.env.START_INTERMEDIO,
      vw: window.innerWidth,
      vh: window.innerHeight,
    };
  },
  methods: {
    visibilityActive(isVisible, entry) {
      if (isVisible) {
        this.$router.push({ hash: "#active" }).catch((err) => {});
      }
    },
    visibilityNotActive(isVisible, entry) {
      if (isVisible) {
        this.$router.push({ hash: "#notActive" }).catch((err) => {});
      }
    },
  },

  computed: {
    ...mapGetters(["isAuthenticated", "authStatus", "getPromotions"]),
    loading: function () {
      return this.authStatus === "loading" && !this.isAuthenticated;
    },
  },
  created: function () {},
  mounted: function () {
    /*var hash = this.$route.hash
		if ( hash && hash != '#home' ){
			this.$scrollTo(hash, 0, {offset: -125})
		}*/
    var _vue = this;
    var hash = _vue.$route.hash;
    if (hash) {
      setTimeout(function () {
        _vue.$scrollTo(hash, 700, { offset: -120 });
      }, 100);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/index.vue